export const titleRoutes = [
  "gallery",
  "photo",
  "wheels",
  "cart",
  "checkout",
  "accessories",
  "make",
  "model",
  "customer-support",
  // 'generation',
]

export const bases: Record<string, string> = {
  wheelLanding: "/wheels",
  constructionType: "/wheels",
  wheelLine: "/wheels/:constructionType",
  bestsellers: "/best-sellers",
  accessory: "/accessories",
  sku: "/shop",
  make: "/vehicles", // /vehicles is a locked route
  model: "/vehicles/:make",
  generation: "/vehicles/:make/:model",
  configuration: "/configure",
  configurationAccessories: "/configure/:id/accessories",
  dynamicPages: "/pages",
  replacementProgram: "/replacement-program",
  replacementEligibility: "/replacement-program",
  articleCategory: "/blog",
  article: "/blog",
  fitmentGuide: "/fitment-guides",
  fitmentGuideMake: "/fitment-guides",
  fitmentGuideModel: "/fitment-guides/:make",
  fitmentGuideGeneration: "/fitment-guides/:make/:model",
  customerSupportArticle: "/customer-support",
  resourceCenterArticle: "/resources",
}